import Farmaceutas from "./AdmiPharmacysContainer";

export default Farmaceutas;
